import React from "react";
import { DateRangePicker } from "@progress/kendo-react-dateinputs";
import { DatePickerContainer } from "./styles";

import { DateRange } from "../../../types/common";

export interface CalendarSetting {
  bottomView: "year" | "decade" | "month" | "century" | undefined;
  topView: "year" | "decade" | "month" | "century" | undefined;
  views: number;
}

interface Props {
  dateRange: DateRange;
  handleChange: (event: any) => void;
  startLabel: string;
  endLabel: string;
  format: string;
  calendarSettings?: CalendarSetting;
  minDate?: Date;
  maxDate?: Date;
}

export default (props: Props) => {
  return (
    <DatePickerContainer style={{ width: "100%" }}>
      <DateRangePicker
        value={props.dateRange}
        onChange={props.handleChange}
        startDateInputSettings={{ label: props.startLabel }}
        endDateInputSettings={{ label: props.endLabel }}
        format={props.format}
        calendarSettings={props.calendarSettings}
        min={props.minDate}
        max={props.maxDate}
      />
    </DatePickerContainer>
  );
};
